/* global window */

export default (typeof window !== 'undefined' ? window : null);
